<template>
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :span="24">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="[16, 8]">
              <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
                <a-form-item label="角色名">
                  <a-input
                    v-model:value="queryParam.roleName"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
                <a-form-item label="权限字符">
                  <a-input
                    v-model:value="queryParam.roleKey"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
                <a-form-item label="创建时间">
                  <a-range-picker
                    style="width: 100%"
                    v-model:value="dateRange"
                    valueFormat="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    allow-clear
                    class="no-border-radius-picker"
                  />
                </a-form-item>
              </a-col>
              <!-- <a-col :md="6" :sm="24">
                <a-form-item label="状态">
                  <a-select
                    placeholder="请选择"
                    v-model:value="queryParam.status"
                    style="width: 100%"
                    allow-clear
                    class="no-border-radius-select"
                  >
                    <a-select-option
                      v-for="(d, index) in dict.type['sys_enable_disable']"
                      :key="index"
                      :value="d.dictValue"
                    >
                      {{ d.dictLabel }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col> -->

              <!-- 按钮区域 -->
              <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
                <a-form-item>
                  <span class="table-page-search-submitButtons">
                    <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                    <a-button style="margin-left: 8px" @click="resetQuery" class="no-border-button">重置</a-button>
                  </span>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operations">
          <a-button
            type="text"
            shape="circle"
            @click="refreshData"
            v-hasPermi="['system:role:refresh']"
            class="refresh-icon-button"
          >
            <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
          </a-button>
          <a-button
            type="primary"
            @click="$refs.createForm.handleAdd()"
            v-hasPermi="['system:role:add']"
            class="add-button"
          >
            <PlusOutlined />新增
          </a-button>
          <a-button
            :disabled="single"
            @click="$refs.createForm.handleUpdate(undefined, ids)"
            v-hasPermi="['system:role:edit']"
            class="no-border-button"
          >
            <EditOutlined />修改
          </a-button>
          <a-button
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['system:role:remove']"
            class="no-border-button"
          >
            <DeleteOutlined />删除
          </a-button>
          <!-- <table-setting
            :style="{ float: 'right' }"
            v-model:table-size="tableSize"
            v-model:value="columns"
            :refresh-loading="loading"
            @refresh="getList"
          /> -->
        </div>
        <!-- 组件 -->
        <create-form
          ref="createForm"
          :status-options="dict.type['sys_enable_disable'] || []"
          @ok="getList"
          @close="getList"
        />

        <!-- 分配角色数据权限对话框 -->
        <create-data-scope-form ref="createDataScopeForm" @ok="getList" />

        <!-- 分配角色脱敏权限对话框 -->
        <create-mask-scope-form ref="createMaskScopeForm" @ok="getList" />

        <!-- 数据表格 -->
        <div style="margin-top: 20px">
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="tableColumns"
            :data-source="list"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
            :pagination="false"
            :bordered="tableBordered"
            :scroll="{ x: 'max-content' }"
            class="optimized-table"
          >
            <template #bodyCell="{ column, record }">
              <template v-if="column.dataIndex === 'status'">
                <span>
                  {{ record.status == 1 ? '正常' : '禁用' }}
                </span>
              </template>
              <!-- 操作列 -->
              <template v-else-if="column.dataIndex === 'operation'">
                <div class="table-action-buttons">
                  <a
                    @click="$refs.createForm.handleUpdate(record, undefined)"
                    v-hasPermi="['system:role:edit']"
                    class="edit-link"
                  >
                    <EditOutlined />
                    修改
                  </a>
                  <span class="action-divider" v-hasPermi="['system:role:remove']">|</span>
                  <a @click="handleDelete(record)" v-hasPermi="['system:role:remove']" class="delete-link">
                    <DeleteOutlined />
                    删除
                  </a>
                  <span class="action-divider" v-hasPermi="['system:role:edit']">|</span>
                  <a-dropdown v-hasPermi="['system:role:edit']">
                    <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                      <DoubleRightOutlined />
                      更多
                    </a>
                    <template v-slot:overlay>
                      <a-menu>
                        <a-menu-item>
                          <a @click="$refs.createDataScopeForm.handleDataScope(record)">
                            <LockOutlined />
                            数据权限
                          </a>
                        </a-menu-item>
                        <a-menu-item>
                          <a @click="handleAuthUser(record)">
                            <UserAddOutlined />
                            分配用户
                          </a>
                        </a-menu-item>
                      </a-menu>
                    </template>
                  </a-dropdown>
                </div>
              </template>
            </template>
            <template v-slot:createTime="record">
              <span>
                {{ parseTime(record.createTime) }}
              </span>
            </template>
          </a-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
          <div class="pagination-left">
            <span class="pagination-info">
              显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第
              {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
            </span>
            <a-select
              v-model:value="queryParam.pageSize"
              style="width: 100px; margin-left: 8px"
              @change="onShowSizeChange(queryParam.pageNum, queryParam.pageSize)"
              class="no-border-radius-select"
            >
              <a-select-option :value="10">10条/页</a-select-option>
              <a-select-option :value="20">20条/页</a-select-option>
              <a-select-option :value="50">50条/页</a-select-option>
              <a-select-option :value="100">100条/页</a-select-option>
            </a-select>
          </div>
          <div class="pagination-right">
            <a-pagination
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :show-total="false"
              @change="changeSize"
            />
            <span class="pagination-jump">
              到第
              <a-input-number
                v-model:value="jumpPage"
                :min="1"
                :max="Math.ceil(total / queryParam.pageSize)"
                style="width: 60px; margin: 0 4px"
                @pressEnter="handleJumpPage"
                class="no-border-radius-input-number"
              />
              页
            </span>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { pageRole, delRole, changeRoleStatus } from '@/api/system/role'
import CreateForm from './modules/CreateForm'
import CreateDataScopeForm from './modules/CreateDataScopeForm'
import CreateMaskScopeForm from './modules/CreateMaskScopeForm'
import { tableMixin } from '@/store/table-mixin'
import { getMaskRoleData, saveMaskRoleData } from '@/api/system/mask'
import { Modal } from 'ant-design-vue'
import {
  SearchOutlined,
  RedoOutlined,
  UpOutlined,
  DownOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  LockOutlined,
  UserAddOutlined,
  DoubleRightOutlined,
} from '@ant-design/icons-vue'

export default {
  name: 'Role',
  components: {
    CreateForm,
    CreateDataScopeForm,
    CreateMaskScopeForm,
    SearchOutlined,
    RedoOutlined,
    UpOutlined,
    DownOutlined,
    PlusOutlined,
    EditOutlined,
    DeleteOutlined,
    LockOutlined,
    UserAddOutlined,
    DoubleRightOutlined,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 日期范围
      dateRange: [],
      // 跳转页码
      jumpPage: 1,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        roleName: undefined,
        roleKey: undefined,
        status: undefined,
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
          width: 80,
          customRender: ({ index }) => {
            const { pageNum, pageSize } = this.queryParam
            return (pageNum - 1) * pageSize + index + 1
          },
        },
        {
          title: '角色编号',
          dataIndex: 'id',
          align: 'center',
        },
        {
          title: '角色名',
          dataIndex: 'roleName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '权限标识',
          dataIndex: 'roleKey',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '排序',
          dataIndex: 'roleSort',
          align: 'center',
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 300,
          fixed: 'right',
          align: 'center',
        },
      ],
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    // 调试：检查字典数据
    this.$nextTick(() => {
      if (this.dict && this.dict.type) {
        console.log('字典数据 sys_enable_disable:', this.dict.type['sys_enable_disable'])
        if (this.dict.type['sys_enable_disable'] && this.dict.type['sys_enable_disable'].length > 0) {
          console.log('第一条数据示例:', this.dict.type['sys_enable_disable'][0])
        } else {
          console.warn('字典数据为空或未加载')
        }
      } else {
        console.warn('字典对象不存在或未初始化')
      }
    })
  },
  computed: {
    submitButtonStyle() {
      return this.advanced ? { float: 'right', overflow: 'hidden' } : {}
    },
    // 表格列配置（返回所有列，包括操作列）
    tableColumns() {
      return this.columns
    },
  },
  watch: {},
  methods: {
    /**
     * 获取字典标签
     * @param {Array} dictList 字典列表
     * @param {String|Number} value 字典值
     * @returns {String} 字典文字
     */
    getDictLabel(dictList, value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      if (!dictList || !Array.isArray(dictList) || dictList.length === 0) {
        return String(value)
      }

      // 将值转换为数字和字符串两种形式进行匹配
      const valueNum = typeof value === 'number' ? value : Number(value)
      const valueStr = String(value)

      const dictItem = dictList.find(
        (item) =>
          item.value === valueStr ||
          item.value === valueNum ||
          String(item.value) === valueStr ||
          Number(item.value) === valueNum
      )

      return dictItem ? dictItem.label : String(value)
    },
    changeStatus(e, record) {
      this.confirmHandleStatus(record)
    },
    /** 查询角色列表 */
    getList() {
      this.loading = true
      pageRole(this.addDateRange(this.queryParam, this.dateRange)).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.jumpPage = this.queryParam.pageNum
        this.loading = false
      })
    },
    /** 查询菜单树结构 */
    getMenuTreeselect() {
      menuTreeselect().then((response) => {
        this.menuOptions = response.data
      })
    },
    // 所有菜单节点数据
    getMenuAllCheckedKeys() {
      // 目前被选中的菜单节点
      let checkedKeys = this.$refs.menu.getCheckedKeys()
      // 半选中的菜单节点
      let halfCheckedKeys = this.$refs.menu.getHalfCheckedKeys()
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys)
      return checkedKeys
    },
    // 所有部门节点数据
    getDeptAllCheckedKeys() {
      // 目前被选中的部门节点
      let checkedKeys = this.$refs.dept.getCheckedKeys()
      // 半选中的部门节点
      let halfCheckedKeys = this.$refs.dept.getHalfCheckedKeys()
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys)
      return checkedKeys
    },
    /** 根据角色ID查询菜单树结构 */
    getRoleMenuTreeselect(roleId) {
      return roleMenuTreeselect(roleId).then((response) => {
        this.menuOptions = response.data.menus
        return response.data
      })
    },
    /** 根据角色ID查询部门树结构 */
    getDeptTree(roleId) {
      return deptTreeSelect(roleId).then((response) => {
        this.deptOptions = response.data.depts
        return response.data
      })
    },
    // 角色状态修改
    handleStatusChange(row) {
      let text = row.status === 1 ? '启用' : '停用'
      this.$modal
        .confirm('确认要"' + text + '""' + row.roleName + '"角色吗？')
        .then(function () {
          return changeRoleStatus(row.id, row.status)
        })
        .then(() => {
          this.$message.error(text + '成功')
        })
        .catch(function () {
          row.status = row.status === 0 ? 0 : 1
        })
    },
    // 脱敏权限状态修改
    handleMaskRoleStatusChange(row) {
      saveMaskRoleData(row).catch(function () {
        row.status = row.status === 0 ? 0 : 1
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 取消按钮（数据权限）
    cancelDataScope() {
      this.openDataScope = false
      this.reset()
    },
    // 表单重置
    reset() {
      if (this.$refs.menu != undefined) {
        this.$refs.menu.setCheckedKeys([])
      }
      ;(this.menuExpand = false),
        (this.menuNodeAll = false),
        (this.deptExpand = true),
        (this.deptNodeAll = false),
        (this.form = {
          roleId: undefined,
          roleName: undefined,
          roleKey: undefined,
          roleSort: 0,
          status: 1,
          menuIds: [],
          deptIds: [],
          menuCheckStrictly: true,
          deptCheckStrictly: true,
          remark: undefined,
        })
      this.resetForm('form')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        roleName: undefined,
        roleKey: undefined,
        status: undefined,
      }
      this.jumpPage = 1
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      this.jumpPage = 1
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.jumpPage = current
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    refreshData() {
      this.getList()
    },
    /* 角色状态修改 */
    confirmHandleStatus(row) {
      const oldStatus = row.status
      const text = row.status === 0 ? '启用' : '关闭'
      const status = row.status === 1 ? 0 : 1

      // row.status = row.status === '0' ? '1' : '0'
      changeRoleStatus(row.id, status)
        .then((res) => {
          if (res.success) {
            row.status = status
            this.$message.success(text + '成功', 3)
          } else {
            row.status = oldStatus
            this.$message.error(`${text}失败, ${res.message}`, 3)
          }
        })
        .catch(() => {
          this.$message.error(text + '异常', 3)
        })
    },
    cancelHandleStatus(row) {},
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const roleIds = row.id || this.ids
      // 获取要删除的角色名
      let roleNames = []
      if (row && row.id) {
        // 单条删除
        roleNames = [row.roleName || '未知角色']
      } else {
        // 批量删除
        roleNames = this.selectedRows.map((item) => item.roleName || '未知角色')
      }
      const roleNamesText = roleNames.length > 0 ? roleNames.join('、') : '未知角色'
      Modal.confirm({
        title: '确认删除所选中数据?',
        content: '当前选中角色名为：' + roleNamesText + ' 的数据',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          return delRole(roleIds).then((res) => {
            if (res.code == 1 || res.code == 20001) {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('删除成功', 3)
            } else {
              that.$message.error(res.message, 3)
            }
          })
        },
        onCancel() {},
      })
    },
    /** 脱敏权限按钮操作 */
    handleMaskData(row) {
      const roleIds = row.id || this.ids
      this.maskRoleId = roleIds
      this.maskRoleDateVisible = true
      getMaskRoleData(row.id).then((response) => {
        this.tableData = response.data
      })
    },

    /** 导出按钮操作 */
    handleExport() {
      var that = this
      Modal.confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          that.download(
            'system/role/export',
            {
              ...that.queryParam,
            },
            `role_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
    /** 分配用户操作 */
    handleAuthUser(row) {
      const roleId = row.id
      this.$router.push({
        path: '/system/role/authUser',
        query: { roleId: roleId },
      })
    },
    /** 跳转页码 */
    handleJumpPage() {
      if (this.jumpPage && this.jumpPage >= 1) {
        const maxPage = Math.ceil(this.total / this.queryParam.pageSize)
        if (this.jumpPage > maxPage) {
          this.jumpPage = maxPage
        }
        this.queryParam.pageNum = this.jumpPage
        this.getList()
      }
    },
  },
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 100px;
  min-width: 100px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 100px;
  text-align: right;
}

/* 输入框样式 */
.no-border-radius-input :deep(.ant-input),
.table-page-search-wrapper :deep(.ant-input) {
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
  width: calc(100% + 20px) !important;
  min-width: calc(100% + 20px) !important;
}

.no-border-radius-input :deep(.ant-input:hover),
.table-page-search-wrapper :deep(.ant-input:hover) {
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.no-border-radius-input :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input:focus) {
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 所有输入框的外层容器（ant-input-affix-wrapper）样式 - allow-clear 时会自动包裹 */
.no-border-radius-input :deep(.ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
  width: calc(100% + 20px) !important;
  min-width: calc(100% + 20px) !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:hover) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
/* 通用规则：当 input 在 affix-wrapper 内时，必须去掉边框避免嵌套 - 最高优先级 */
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper > .ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper input.ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:hover),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:focus),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper input.ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

/* 日期选择器样式 */
.no-border-radius-picker :deep(.ant-picker),
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
  width: calc(100% + 20px) !important;
  min-width: calc(100% + 20px) !important;
}

.no-border-radius-picker :deep(.ant-picker:hover),
.table-page-search-wrapper :deep(.ant-picker:hover) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框样式 */
.no-border-radius-select :deep(.ant-select-selector),
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.no-border-radius-select :deep(.ant-select-selector:hover),
.table-page-search-wrapper :deep(.ant-select-selector:hover) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.no-border-radius-input-number :deep(.ant-input-number),
.table-page-search-wrapper :deep(.ant-input-number) {
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.no-border-radius-input-number :deep(.ant-input-number:hover),
.table-page-search-wrapper :deep(.ant-input-number:hover) {
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-focused),
.table-page-search-wrapper :deep(.ant-input-number-focused) {
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input),
.table-page-search-wrapper :deep(.ant-input-number-input) {
  border-radius: 4px !important;
}

/* 移除搜索栏输入框、下拉选择框、日期选择框聚焦时的高亮效果 */
/* 输入框聚焦样式 - 内部input隐藏边框 */
.no-border-radius-input :deep(.ant-input:focus),
.no-border-radius-input :deep(.ant-input-focused),
.table-page-search-wrapper :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 带前缀/后缀的输入框聚焦样式 - 外部容器保持边框，内部input隐藏边框 */
.no-border-radius-input :deep(.ant-input-affix-wrapper:focus),
.no-border-radius-input :deep(.ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 聚焦时，内部input隐藏边框 */
.no-border-radius-input :deep(.ant-input-affix-wrapper:focus .ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 下拉选择框聚焦样式 */
.no-border-radius-select :deep(.ant-select-selector:focus),
.no-border-radius-select :deep(.ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector:focus),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择框聚焦样式 */
.no-border-radius-picker :deep(.ant-picker:focus),
.no-border-radius-picker :deep(.ant-picker-focused),
.table-page-search-wrapper :deep(.ant-picker:focus),
.table-page-search-wrapper :deep(.ant-picker-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 0 !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 其他按钮去掉圆角 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 0;
}

.table-operations :deep(.ant-btn) {
  border-radius: 0;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 4px !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 分页组件样式 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 4px !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button:hover:not(:disabled),
.no-border-button:focus:not(:disabled) {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

/* 禁用状态样式 */
.no-border-button:disabled,
.no-border-button[disabled] {
  border: none !important;
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed !important;
}

.no-border-button:disabled:hover,
.no-border-button:disabled:focus,
.no-border-button[disabled]:hover,
.no-border-button[disabled]:focus {
  border: none !important;
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
}

/* 展开/收起按钮文字和图标颜色 */
.toggle-button {
  color: #165dff !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button:hover,
.toggle-button:focus {
  color: #165dff !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap; /* 防止操作按钮换行 */
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

/* 编辑按钮颜色 */
.table-action-buttons .edit-link {
  color: #165dff !important;
}

.table-action-buttons .edit-link:hover {
  color: #4080ff !important;
}

/* 删除按钮颜色 */
.table-action-buttons .delete-link {
  color: #ff4d4f !important;
}

.table-action-buttons .delete-link:hover {
  color: #ff7875 !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

/* Confirm 弹窗按钮样式 */
:deep(.ant-modal-confirm .ant-btn-primary) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:hover) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:focus) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:active) {
  background-color: #0e4acc !important;
  border-color: #0e4acc !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-default) {
  background-color: #f2f2f2 !important;
  border-color: #f2f2f2 !important;
  color: #333333 !important;
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-default:hover) {
  background-color: #e5e5e5 !important;
  border-color: #e5e5e5 !important;
  color: #333333 !important;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.refresh-icon-button img {
  width: 32px;
  height: 32px;
}
</style>
